<template>
  <nav class="dg-global-breadcrumb">
    <div class="breadcrumbs-sub-wrapper">
      <span
        v-for="(item, index) in breadcrumbItems"
        :key="index"
        class="item-wrapper"
      >
        <template
          v-for="isFinalCrumb in [(breadcrumbItems.length === index + 1)]"
          :key="isFinalCrumb"
        >
          <component
            :is="isFinalCrumb ? 'span' : 'router-link'"
            :to="item.to"
            :class="['item', { current: isFinalCrumb }]"
          >
            <img
              v-if="item.icon"
              :src="item.icon"
              class="icon"
            >
            {{ item.text }}
          </component>
          <span
            v-if="!isFinalCrumb"
            class="divider"
          >/</span>
        </template>
      </span>
    </div>
    <!--
    TODO: Replace the below with this once the new event process works
    <MultiButton label="Create">
      <p @click="onOpneForNewRally">Create New Rally</p>
      <p @click="onOpneForSpecialEvents">Create Special Event</p>
      <p @click="onOpneForQuickEvents">Create Quick Event</p>
    </MultiButton>
    -->
    <router-link
      v-if="$route.name === 'dashboard'"
      to="/start"
      class="dg-multi-button"
      style="text-decoration: none;"
    >
      <button
        class="desktop-button"
        style="display: inline-block; padding-left: 0;"
      >
        <span>Create New Rally</span>
      </button>
    </router-link>
  </nav>
</template>

<script>
  import { mapState } from "vuex";
  import { rallyAttributesIsHub } from "../common";
  import MultiButton from "./MultiButton";

  export default {
    name: "GlobalBreadcrumb",
    components: {
      MultiButton,
    },
    computed: {
      ...mapState("rallies", ["rallyChannelsByRallyId", "allRalliesByRallyId"]),
      breadcrumbItems() {
        const route = this.$route

        // Exit early if you are on the Dashboard
        if ( route.name === 'dashboard' ) {
          return [{ text: route.meta.title }]
        }

        const items = [{ text: "My Rallyhood", to: "/rallies" }]
        const dashboardRoutes = ['feed', 'messaging', 'messaging-sub', 'my-calendar', 'user-settings']

        // Exit early if you are on a Dashboard sub-page
        if ( dashboardRoutes.includes(route.name) ) {
          items.push({
            text: route.meta.title,
            to: route.meta.path,
          })
          return items
        }

        const rallyId = route.params?.rallyId

        // Exit early if there is some path that I don't know about.
        if ( !rallyId ) {
          return items
        }

        const rally = this.allRalliesByRallyId[rallyId]?.rally

        // Exit early if there is some path that I don't know about.
        if ( !rally ) {
          return items
        }

        const parentRally = rally?.attributes?.parent
        const isChild = ( parentRally && parentRally.type === 'Standard' && this.allRalliesByRallyId[rallyId]?.rally?.attributes['parent-relationship-type'] != 'HiddenOrg' )

        // Append the parent hub if present.
        if ( isChild ) {
          items.push({
            text: parentRally.title,
            to: `/${parentRally.id}`,
            icon: "/icons/hubicon_grey.svg",
          })
        }

        const channels = this.rallyChannelsByRallyId?.[rallyId]

        // Channels for this rally haven't arrived yet (race on first nav,
        // RCHANS slow/down, or the rally has no channels). Show the rally
        // crumb without channel decoration and bail before any indexing.
        if ( !Array.isArray(channels) || channels.length === 0 ) {
          items.push({
            text: rally.attributes.title,
            icon: "/icons/rallyicon.svg",
          })
          return items
        }

        // This is only needed until Special Event slugs stop using ?fundraiser_type=
        let slug = route.params.channelSlug
        const queryParams = route.href.split('?')[1]
        if ( queryParams ) slug = slug.concat('?', queryParams)

        const channel = channels.find(item => (item.attributes.slug.indexOf(slug) >= 0))
        const isFirstChannel = ( channels[0].id == channel?.id )
        const isHub = channels?.find(item => (item.attributes.type.indexOf('Groups') >= 0))
        const rallyIconPrefix = isHub ? "hub" : "rally"
        const rallyIconSuffix = isFirstChannel ? "" : "_grey"

        // Append the current rally or hub name.
        items.push({
          text: rally.attributes.title,
          to: `/${rallyId}`,
          icon: `/icons/${rallyIconPrefix}icon${rallyIconSuffix}.svg`,
        })

        // Append the channel name.
        if ( channel && !isFirstChannel ) {
          items.push({text: channel.attributes.name})
        }

        return items
      },
    },
  };
</script>
